import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CHost, BHost } from "../constants";
import { currentDomainName } from "./cac-config";
import DefaultConfiguration from "./configuration";
import { removeCst } from "./cst"; // FIXME: 这个文件和 url.ts 存在循环依赖的可能性

import { getRealMultiUrl } from "./multi-user"; // FIXME: 这个文件和 url.ts 存在循环依赖的可能性

/**
 * 交换域名
 */

function getTargetDomain(domain) {
  return domain === CHost ? BHost : CHost;
}

export function getQuery(key, url) {
  var location = url || global.location || '';
  var m = getSearch(location).match(new RegExp("(\\?|&)".concat(key, "=([^&]*)(#|&|$)")));
  return !m ? '' : decodeURIComponent(m[2]);
}
/**
 * FIXME: 可以直接用 URLSearchParams 对象处理
 */

export function removeURLParameter(url, parameter) {
  // prefer to use l.search if you have a location/link object
  var _url$split = url.split('?'),
      _url$split2 = _slicedToArray(_url$split, 2),
      path = _url$split2[0],
      search = _url$split2[1];

  if (search) {
    var prefix = "".concat(encodeURIComponent(parameter), "=");
    var pars = search.split(/[&]/g); // reverse iteration as may be destructive
    // eslint-disable-next-line no-plusplus

    for (var i = pars.length; i-- > 0;) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = path + (pars.length > 0 ? "?".concat(pars.join('&')) : '');
    return url;
  }

  return url;
}
export function getSearch(url) {
  if (typeof url === 'string') {
    return url;
  }

  return url.search;
}
export function isScenarioLink(url) {
  return url.includes('/scenario/link.html');
}
export function isQQDomain(url) {
  return /\.qq\.com/.test(url);
}
/**
 * 将链接转换成https头
 */

export function getHttpsUrl(url) {
  if (isQQDomain(url)) {
    return url.replace(/^(http:)?\/\//i, 'https://');
  }

  return url;
}
/**
 * 检查是否需要跳中转页
 * @param url
 * @param options
 * @returns
 */

export function isNeedScenarioRedirectLink(url, defaultOptions, options) {
  var _ref = defaultOptions || {},
      ignoreDomainDetect = _ref.ignoreDomainDetect; // 是否是需要忽略跳转的域名


  var isIgnoreHost = checkIgnoreHost(defaultOptions);
  var needRedirect = !isQQDomain(url) && !isScenarioLink(url);
  var needOpenPanel = !isQQDomain(url) && !isScenarioLink(url); // 非需要忽略跳转的域名，没有设置不用跳转，也没有设置全局忽略跳转

  if (isIgnoreHost || options !== null && options !== void 0 && options.ignoreDomainDetect || ignoreDomainDetect) {
    needRedirect = false;
  }

  if (!needRedirect && !needOpenPanel || !ignoreDomainDetect) {
    needOpenPanel = false;
  }

  return {
    needRedirect: needRedirect,
    needOpenPanel: needOpenPanel
  };
}
export function oldNeedScenarioRedirectLink(url, options) {
  return (!isQQDomain(url) || isScenarioLink(url)) && !(options !== null && options !== void 0 && options.ignoreDomainDetect);
}
/**
 * 获取最终跳转链接，用一个新的方法来兼容，preprocessUrl 部分品类有单独使用
 * @param url
 * @param options
 * @returns
 */

export function getPreprocessUrl(url, options) {
  var theUrl = removeCst(url);

  if (!theUrl) {
    return null;
  }

  var defaultOptions = DefaultConfiguration.getOptions();
  theUrl = getHttpsUrl(url);
  /**
   * 【C端文档专属逻辑，B端直接信任三方链接，不需要中转了】
   *  假如不是 qq.com 域名，且没有传域名忽略参数的
   *  需要经过 scenario 中转跳转
   */

  var _isNeedScenarioRedire = isNeedScenarioRedirectLink(url, defaultOptions, options),
      needRedirect = _isNeedScenarioRedire.needRedirect,
      needOpenPanel = _isNeedScenarioRedire.needOpenPanel;

  if (needRedirect) {
    theUrl = "//".concat(currentDomainName, "/scenario/link.html?url=").concat(encodeURIComponent(theUrl));
    var _ref2 = window,
        clientVars = _ref2.clientVars;

    if (clientVars) {
      theUrl = "".concat(theUrl, "&pid=").concat(clientVars.globalPadId, "&cid=").concat(clientVars.creatorId);
    }
  }

  var noUserIndex = options === null || options === void 0 ? void 0 : options.noUserIndex; // 特定情况下，可以不用加u

  if (!noUserIndex) {
    theUrl = getRealMultiUrl(theUrl);
  }

  return {
    url: theUrl,
    callback: needOpenPanel ? defaultOptions.ignoreDomainDetectCallback : undefined
  };
}
export function preprocessUrl(url, options) {
  var theUrl = removeCst(url);

  if (!theUrl) {
    return null;
  }

  var defaultOptions = DefaultConfiguration.getOptions();
  theUrl = getHttpsUrl(url);
  /**
   * 【C端文档专属逻辑，B端直接信任三方链接，不需要中转了】
   *  假如不是 qq.com 域名，且没有传域名忽略参数的
   *  需要经过 scenario 中转跳转
   */

  if (oldNeedScenarioRedirectLink(url, defaultOptions)) {
    theUrl = "//".concat(currentDomainName, "/scenario/link.html?url=").concat(encodeURIComponent(theUrl));
    var _ref3 = window,
        clientVars = _ref3.clientVars;

    if (clientVars) {
      theUrl = "".concat(theUrl, "&pid=").concat(clientVars.globalPadId, "&cid=").concat(clientVars.creatorId);
    }
  }

  var noUserIndex = options === null || options === void 0 ? void 0 : options.noUserIndex; // 特定情况下，可以不用加u

  if (!noUserIndex) {
    theUrl = getRealMultiUrl(theUrl);
  }

  return theUrl;
} // 获取b/c跳转的链接

export function getTargetUrl(url, scenarioUrl, domain) {
  // 先把要交换的域名取到
  var targetDomain = getTargetDomain(domain);
  var theUrl = !scenarioUrl ? url.replace(domain, targetDomain) : scenarioUrl.replace(domain, targetDomain); // 交换到同域

  var targetUrl = theUrl.replace(domain, targetDomain);

  if (!scenarioUrl) {
    return targetUrl;
  }

  var symbol = '&';

  if (scenarioUrl.indexOf('?') < 0) {
    symbol = '?';
  }

  return "".concat(scenarioUrl).concat(symbol, "url=").concat(encodeURIComponent(url));
}
export function triggerAnchorClick(a) {
  // url一致时，点击<a>标签不会跳转，直接刷新当前页面
  if (a.href === location.href && a.target === '_self') {
    location.reload();
    return;
  }

  var event = document.createEvent('MouseEvents');
  event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  a.dispatchEvent(event);
}

function checkIgnoreHost(defaultOptions) {
  var _ref4 = defaultOptions || {},
      ignoreHosts = _ref4.ignoreHosts;

  var isIgnoreHost = false;

  if (ignoreHosts) {
    isIgnoreHost = ignoreHosts.includes(currentDomainName);
  }

  return isIgnoreHost;
}